import { Box, Typography } from "@mui/material";
import CustomTable from "../../../../../common/CustomTable/CustomTable";
import CoveragesAndLimitsStyles from "./CoveragesAndLimitsStyles";
import CustomIcon from "../../../../../common/CustomIcon/CustomIcon";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../store/hooks";
import { RootState } from "../../../../../store/store";

interface IAddFormRequestBody {
  label: string;
  accessorKey?: string;
  Cell?: any;
}

interface IProps {
  columns: IAddFormRequestBody[];
  data: any[];
  sectionTitle: string;
}

const CoveragesAndLimits = (props: IProps) => {
  const { data, columns, sectionTitle } = props;

  const { t } = useTranslation();
  const { calledReducerType, isLoading } = useAppSelector(
    (store: RootState) => store.common
  );

  const getCoveragesSection = () => {
    return (
      <CustomTable
        columns={columns}
        data={data}
        displaySkeleton={
          isLoading &&
          calledReducerType === "policyDetails/GetPolicyCoveragesAndDiscounts"
        }
      />
    );
  };

  return (
    <>
      <Box
        id="coverages_limits_section"
        data-test-id="coverages_limits_section"
        aria-label={`${sectionTitle} section`}
      >
        <Box 
          sx={CoveragesAndLimitsStyles.coverageAndLimitsHeading}
          id="coverages_limits_header"
          data-test-id="coverages_limits_header"
          aria-label={`${sectionTitle} header`}
        >
          <Box
            id="coverages_limits_icon"
            data-test-id="coverages_limits_icon"
            aria-label="Coverages icon"
          >
            <CustomIcon iconName="Coverages" />
          </Box>
          <Typography
            sx={CoveragesAndLimitsStyles.coverageAndLimitsHeadingText}
            id="coverages_limits_title"
            data-test-id="coverages_limits_title"
            aria-label={t(sectionTitle)}
          >
            {t(sectionTitle)}
          </Typography>
        </Box>
        {getCoveragesSection()}
      </Box>
    </>
  );
};

export default CoveragesAndLimits;
